import QuizBanner from './QuizBanner';

export default function QuizBannerSmall() {
  return <QuizBanner variant="small" />;
}
